export default __webpack_public_path__ + "static/danieli-mobile-app-a5569a89216aefcb9b24c2dd05972675.png";